export default function SupplierIntro({ companyName, onContinue }) {
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <div className="max-w-2xl text-center">
        <img src="https://static.wixstatic.com/media/cf458d_f7329a8f179a4571a1951c4ed9431604~mv2.png" alt="NEG" className="h-10 mx-auto mb-8 opacity-60" />
        <h1 className="font-display text-3xl sm:text-4xl text-white mb-3">Welcome to the<br /><span className="text-brand-gold">Beverage Collective</span></h1>
        <p className="text-neutral-400 text-sm mb-8 max-w-lg mx-auto leading-relaxed">
          A hospitality-focused marketing, activation, education, analytics, and beverage strategy platform administered by Next Experience Group.
        </p>

        <div className="card p-6 text-left mb-6">
          <h2 className="text-sm font-semibold text-brand-gold mb-4">As a Supplier Partner, You Have Access To:</h2>
          <div className="grid sm:grid-cols-2 gap-4">
            {[
              { icon: '📊', title: 'Operator Portfolio', desc: 'See every participating operator, their market, venue type, cuisine, and category tier — helping you prioritize where to invest.' },
              { icon: '🎯', title: 'Tier-Based Insights', desc: 'Understand each operator\'s category support level across Liquor, Beer, Wine, and Non-Alcoholic — from Baseline to Flagship.' },
              { icon: '💰', title: 'Your Commitments', desc: 'View your specific package commitments, costs per tier, SKU allocations, and quarterly investment summary.' },
              { icon: '📅', title: 'Activation Calendar', desc: 'See planned, active, and completed activations across the portfolio — education, tastings, menu features, and more.' },
            ].map((item, i) => (
              <div key={i} className="flex gap-3">
                <span className="text-xl flex-shrink-0 mt-0.5">{item.icon}</span>
                <div>
                  <p className="text-xs font-semibold text-white mb-1">{item.title}</p>
                  <p className="text-[10px] text-neutral-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="card p-4 mb-8" style={{ borderLeft: '3px solid #C9A668' }}>
          <p className="text-[10px] text-neutral-500 leading-relaxed">
            The Beverage Collective is not a rebate program, purchasing consortium, or guaranteed placement system.
            All activities are conducted in compliance with applicable federal, state, and local beverage regulations.
            Supplier marketing support funds are used solely for legitimate marketing, educational, and consumer engagement activities.
          </p>
        </div>

        <button onClick={onContinue} className="btn-primary text-sm px-10 py-4">
          Enter Dashboard
        </button>

        <p className="text-neutral-700 text-[9px] mt-6">NEG Proprietary Category Support Scoring System</p>
      </div>
    </div>
  );
}
